import * as Yup from 'yup';
import { MESSAGE_ERREUR_MESSAGEDEMANDE_OBLIGATOIRE, MESSAGE_ERREUR_TYPEDEMANDE_OBLIGATOIRE,
  MESSAGE_ERREUR_MESSAGEREPONSE_OBLIGATOIRE, MESSAGE_ERREUR_TYPEREPONSE_OBLIGATOIRE,
 } from '../../../../data/message-erreurs-form';



export const messageDemandeSchema = Yup.object().shape({
    IdTypeDemande: Yup
    .number()
    .required(MESSAGE_ERREUR_TYPEDEMANDE_OBLIGATOIRE)
    .typeError(MESSAGE_ERREUR_TYPEDEMANDE_OBLIGATOIRE),
    MessageDemande: Yup
      .string()
      .required(MESSAGE_ERREUR_MESSAGEDEMANDE_OBLIGATOIRE)
      .typeError(MESSAGE_ERREUR_MESSAGEDEMANDE_OBLIGATOIRE),
  });

  export const messageReponseSchema = Yup.object().shape({
    IdTypeReponse: Yup
    .number()
    .required(MESSAGE_ERREUR_TYPEREPONSE_OBLIGATOIRE)
    .typeError(MESSAGE_ERREUR_TYPEREPONSE_OBLIGATOIRE),
    MessageReponse: Yup
      .string()
      .required(MESSAGE_ERREUR_MESSAGEREPONSE_OBLIGATOIRE)
      .typeError(MESSAGE_ERREUR_MESSAGEREPONSE_OBLIGATOIRE),
  });

